import React from 'react'
import { NavIn3 } from '../components/componentNav/NavIn'
import { Legals } from '../components/ComponentExtras/Legales'


export  function DenederLegals() {
  return (
    <>
        <NavIn3 />
        <Legals/>
    </>
  )
}
